import { IPMessage } from '../../models/pmessage.model';

export enum LoadingState {
  NONE,
  LOADING,
  SUCCESS,
  FAIL,
}

export interface ILoaderActionPayload {
  value: LoadingState;
  message?: IPMessage;
}
